module.exports = __webpack_public_path__ + "static/agora-32c42935741a39086b8733aa5c56dc50.png";